import { useState, useCallback } from 'react'
import { NotificationType } from '../components/Notification/Notification'

export function useNotification() {
  const [notifications, setNotifications] = useState<NotificationType[]>([])
  const [shownNotifications, setShownNotifications] = useState<Set<string>>(new Set())

  const addNotification = useCallback((notification: Omit<NotificationType, 'id'>) => {
    const id = `notif-${Date.now()}-${Math.random()}`
    const newNotification: NotificationType = {
      ...notification,
      id
    }
    
    setNotifications(prev => [...prev, newNotification])
    return id
  }, [])

  const addNotificationOnce = useCallback((key: string, notification: Omit<NotificationType, 'id'>) => {
    if (shownNotifications.has(key)) {
      return null
    }
    
    setShownNotifications(prev => new Set(prev).add(key))
    return addNotification(notification)
  }, [shownNotifications, addNotification])

  const removeNotification = useCallback((id: string) => {
    setNotifications(prev => prev.filter(n => n.id !== id))
  }, [])

  const clearAll = useCallback(() => {
    setNotifications([])
  }, [])

  return {
    notifications,
    addNotification,
    addNotificationOnce,
    removeNotification,
    clearAll
  }
}